/* Provides guided walkthrough state to the app. Place inside AppLayout. */

import type { ReactNode } from "react";
import { GuidedWalkthroughContext } from "@/contexts/guidedWalkthroughContextValue";
import { useGuidedWalkthrough } from "@/hooks/useGuidedWalkthrough";

interface GuidedWalkthroughProviderProps {
  children: ReactNode;
}

export function GuidedWalkthroughProvider({ children }: GuidedWalkthroughProviderProps) {
  const walkthrough = useGuidedWalkthrough();

  return (
    <GuidedWalkthroughContext value={walkthrough}>
      {children}
    </GuidedWalkthroughContext>
  );
}
